import { render } from "./GallerySimple.vue?vue&type=template&id=87a61d5c&scoped=true"
import script from "./GallerySimple.vue?vue&type=script&lang=js"
export * from "./GallerySimple.vue?vue&type=script&lang=js"

import "./GallerySimple.vue?vue&type=style&index=0&id=87a61d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a61d5c"]])

export default __exports__